import { render, staticRenderFns } from "./faqList.vue?vue&type=template&id=6a902c86"
import script from "./faqList.vue?vue&type=script&lang=js"
export * from "./faqList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports